<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<header class="contract-page__header">
  <div class="contract-page__heading">
    <h1>Modelo do contrato de parceria</h1>
    @if (current(); as template) {
      <p class="contract-page__meta">
        <span class="contract-page__chip">Versão vigente v{{ template.version }}</span>
        Salva em {{ template.createdAt | vaultDateTime }}
        @if (template.createdByName) {
          por {{ template.createdByName }}
        }
      </p>
    }
  </div>

  <div class="contract-page__actions">
    <app-button
      [label]="historyOpen() ? 'Ocultar histórico' : 'Histórico'"
      icon="pi pi-history"
      theme="white"
      (sendButtonClick)="toggleHistory()" />
    @if (!readOnly()) {
      <app-button
        label="Salvar nova versão"
        icon="pi pi-check"
        title="Salvar nova versão (Ctrl+S)"
        [isLoading]="saving()"
        loadingText="Salvando..."
        [disabled]="!canSave()"
        (sendButtonClick)="save()" />
    }
  </div>
</header>

@if (loading()) {
  <app-loading />
} @else {
  <div class="contract-page__layout" [class.contract-page__layout--with-aside]="historyOpen()">
    <section class="contract-page__main">
      @if (readOnly()) {
        <div class="contract-page__notice contract-page__notice--warn" role="status">
          <i class="pi pi-lock"></i>
          <span>{{ textLockedMessage }}</span>
        </div>
      }

      <div class="contract-page__notice contract-page__notice--info" role="note">
        <i class="pi pi-info-circle"></i>
        <span>
          Use o botão <strong>Variável</strong> para inserir dados que mudam por parceiro, como a
          razão social ou o CNPJ. Eles aparecem no texto como <code>{{ variableExample }}</code> e
          são preenchidos quando o contrato é gerado.
        </span>
      </div>

      @if (viewing(); as old) {
        <div class="contract-page__notice contract-page__notice--warn" role="status">
          <i class="pi pi-eye"></i>
          <span>
            Você está vendo a <strong>versão {{ old.version }}</strong
            >, salva em {{ old.createdAt | vaultDateTime }}. Ela é só para leitura.
          </span>
          <div class="contract-page__notice-actions">
            <app-button
              label="Voltar para a vigente"
              theme="white"
              size="small"
              (sendButtonClick)="closeViewing()" />
            @if (!readOnly()) {
              <app-button
                label="Usar como base"
                icon="pi pi-copy"
                size="small"
                (sendButtonClick)="useViewingAsBase()" />
            }
          </div>
        </div>

        <app-rich-text-editor [formControl]="viewingBodyControl" [readonly]="true" />
      }

      <!-- O editor da versão em edição fica montado (só escondido) enquanto uma versão antiga é
           lida, para não perder o desfazer nem o texto em andamento. -->
      <div [class.contract-page__hidden]="!!viewing()">
        @if (!readOnly()) {
          <div class="contract-page__change-note">
            <app-input
              label="O que mudou nesta versão"
              placeholder="Ex.: ajuste na cláusula de remuneração (aparece no histórico)"
              [formControl]="changeNoteControl"
              [maxLength]="500" />
          </div>
        }

        <app-rich-text-editor
          [formControl]="bodyControl"
          [variables]="variables()"
          [readonly]="readOnly()" />
      </div>
    </section>

    @if (historyOpen()) {
      <div class="contract-page__aside">
        <app-partner-contract-template-history
          [versions]="versions()"
          [selectedId]="viewing()?.id ?? null"
          [loading]="versionsLoading()"
          (selectVersion)="openVersion($event)"
          (collapse)="toggleHistory()" />
      </div>
    }
  </div>
}
